import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { BookActivityForm } from "../BookActivityForm";
import { CreateBookActivityModalProps } from "./types";
import { useCreateBookActivityModal } from "./controller";

export const CreateBookActivityModal = React.memo(({ modalRef, onComplete }: CreateBookActivityModalProps) => {
  const translate = useTranslate();

  const { methods, mutateAsync, isPending } = useCreateBookActivityModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("book_activity_admin.titles.create")}
      onConfirm={mutateAsync}
      methods={methods}
      isPending={isPending}
    >
      <BookActivityForm />
    </Modal>
  );
});
